import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../lib/supabase.js';
import { runAppDataFetch, DEFAULT_APP_FETCH_MS } from '../../lib/appDataFetch.js';
import { useAppSession } from '../../lib/appSessionBridge.js';

/**
 * Fila `profiles` del usuario autenticado (lectura/actualización desde el cliente).
 */
export function useProfile(userId) {
  const { authReady, dataRefreshKey } = useAppSession();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(!!userId);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!userId) {
      setProfile(null);
      setLoading(false);
      setError(null);
      return;
    }
    if (!authReady) return;
    setLoading(true);
    setError(null);
    try {
      const { data, error: err } = await runAppDataFetch(
        () => supabase.from('profiles').select('*').eq('id', userId).maybeSingle(),
        {
          timeoutMs: DEFAULT_APP_FETCH_MS,
          timeoutMessage: 'Tiempo de espera al cargar el perfil. Revisa la conexión o Supabase.',
        }
      );
      if (err) {
        setError(err.message);
        setProfile(null);
        return;
      }
      setProfile(data ?? null);
    } catch (e) {
      setError(e?.message || 'Error al cargar el perfil');
      setProfile(null);
    } finally {
      setLoading(false);
    }
  }, [userId, authReady]);

  useEffect(() => {
    refetch();
  }, [refetch, dataRefreshKey]);

  return { profile, loading, error, refetch };
}
